<script lang="ts">
  import Button from "$lib/components/ui/button/button.svelte";

  interface Props {
    text: string;
    onclick: () => void;
  }

  let { text = "COUPON", onclick }: Props = $props();
</script>

<Button
  class="bg-primary hover:bg-primary/80 text-primary-foreground flex items-center justify-center gap-1 py-6 font-extrabold rounded-sm transition-all duration-300"
  {onclick}
>
  <svg
    viewBox="0 0 35 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="size-10!"
  >
    <path
      d="M0 8.59859L26.6949 0L34.7947 33.1033L12.9496 41L0 8.59859Z"
      fill="white"
    />
    <path
      d="M14.5871 38.0347L4.28125 10.4632L25.3349 3.46484L33.2916 31.8135L14.5871 38.0347Z"
      fill="#0D0D0D"
    />
    <path
      d="M15.0645 11.8413C15.3844 11.858 15.6791 12.0042 15.9528 12.2758C16.2264 12.5474 16.4706 13.0028 16.6853 13.6337C16.9758 14.4986 17.0094 15.1462 16.7821 15.5765C16.5548 16.0069 16.117 16.3286 15.4686 16.5417C14.8498 16.7464 14.3193 16.7422 13.8857 16.5208C13.4521 16.3035 13.0985 15.798 12.8333 15.0083C12.5638 14.2103 12.5217 13.5668 12.7069 13.078C12.8922 12.5892 13.3048 12.2382 13.9447 12.0251C14.3741 11.8872 14.7487 11.8246 15.0645 11.8413ZM15.5781 15.0793C15.5865 14.8495 15.5192 14.5236 15.3718 14.0891C15.2245 13.6546 15.0771 13.3496 14.9214 13.1616C14.7656 12.9777 14.5719 12.9192 14.3362 12.9861L14.2646 13.0111C14.092 13.0696 13.9825 13.1365 13.9447 13.2117C13.911 13.2744 13.9236 13.4415 13.9741 13.7089C14.0246 13.9763 14.0962 14.2437 14.1888 14.5111C14.3404 14.9623 14.4962 15.2673 14.6477 15.4177C14.7993 15.5682 14.9803 15.6099 15.1824 15.5431C15.435 15.4637 15.5655 15.3091 15.5781 15.0793ZM18.6176 10.4917L20.4068 9.89844L17.9651 20.3354L16.1759 20.9287L18.6176 10.4917ZM22.0866 14.1601C22.4065 14.1768 22.7012 14.3231 22.9749 14.5947C23.2485 14.8662 23.4927 15.3217 23.7074 15.9567C23.9979 16.8216 24.0316 17.4692 23.8042 17.8996C23.5769 18.3299 23.1391 18.6516 22.4907 18.8647C21.8719 19.0694 21.3414 19.0653 20.9078 18.8438C20.4742 18.6266 20.1206 18.121 19.8553 17.3313C19.5859 16.5333 19.5438 15.8899 19.729 15.401C19.9143 14.9122 20.3268 14.5612 20.9667 14.3481C21.3962 14.2061 21.7708 14.1434 22.0866 14.1601ZM22.6002 17.3982C22.6086 17.1726 22.5412 16.8425 22.3939 16.408C22.2466 15.9734 22.0992 15.6684 21.9434 15.4804C21.7877 15.2966 21.594 15.2381 21.3583 15.3049L21.2867 15.33C21.1141 15.3885 21.0046 15.4554 20.9667 15.5306C20.9331 15.5932 20.9457 15.7604 20.9962 16.0278C21.0467 16.2952 21.1183 16.5626 21.2109 16.83C21.3625 17.2812 21.5182 17.582 21.6698 17.7366C21.8256 17.887 22.0024 17.9288 22.2045 17.862C22.4613 17.7826 22.5918 17.628 22.6002 17.3982Z"
      fill="white"
    />
    <path
      d="M10.8615 29.7614L10.4531 27.9731L13.5263 26.9913L14.0905 28.7294L10.8615 29.7614ZM15.6229 28.2405L15.0587 26.5024L17.6899 25.6626L18.254 27.4007L15.6229 28.2405ZM19.7907 26.9119L19.2265 25.1738L21.8577 24.334L22.4218 26.0721L19.7907 26.9119ZM23.95 25.579L23.3859 23.8409L26.0171 23.0011L26.5812 24.7392L23.95 25.579ZM28.1178 24.2504L27.5537 22.5123L30.5932 21.543L31.1363 23.2894L28.1178 24.2504Z"
      fill="white"
    />
  </svg>

  {text}
</Button>
